import styled from 'styled-components'
import { InteractionsAnim } from 'animations/Interactions'

const { textClick } = InteractionsAnim()

interface BACK_STYLED_PROPS {
  anim?: boolean
}
export const BackDiv = styled.div<BACK_STYLED_PROPS>`
  text-align: center;
  font-size: 20px;
  margin-top: 24px;
  font-size: 20px;
  cursor: pointer;
  text-transform: uppercase;
  ${({ anim }) => anim && textClick};
`
